import axios from 'axios';

const RestClient = axios.create({
  baseURL: process.env.REACT_APP_URL
});


export const createClient = (baseURL) => {
  return axios.create({baseURL});
}

export default RestClient;